// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1o-iK","range":"MonthRangeSwitch_range__3pP-B","disabled":"MonthRangeSwitch_disabled__3u6Gx"};